import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';
import PartnerModal from '../PartnerModal';
import { useState } from 'react';
import EcoButton from 'eco-design/base/eco-button';
import gtm from '@/utils/gtm';

const SectionCard2: React.FC = () => {
    const [modalVisible, setModalVisible] = useState(false);

    const { t } = useLang('theProduct.SectionCard2');

    const handleClick = () => {
        setModalVisible(true);
        gtm.push({
            __btn_id1: 'SectionCard2 .modal',
            __btn_id2: t(`btn`),
            __btn_type: 'common',
        });
    };
    return (
        <div
            className={`${styles.SectionCard2} SectionCard2 GtmModuleData-section`}
            id="SectionCard2"
            data-section-id={styles.SectionCard2}
            data-section-title={t('title')}
        >
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />

            <div className="btn-container">
                <EcoButton onClick={handleClick} className="modal GtmModuleData-btn-common" lRadius="ellipse" lSize="large">
                    {t(`btn`)}
                </EcoButton>
            </div>

            <div className="eco-content">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1760947081537/SectionCard2-pc.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1760947081537/SectionCard2-pc.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1761011661429/SectionCard2-h5.jpg"
                />
                {/* <EcoImg className="img-flag" pc="https://websiteoss.ecoflow.com/upload/image/1755152965798/15year_eu.png" /> */}
            </div>
            <PartnerModal visible={modalVisible} onClose={() => setModalVisible(false)} />
        </div>
    );
};

export default SectionCard2;
